import * as React from "react";

interface SliderProps {
  value?: number | number[];
  min?: number;
  max?: number;
  step?: number;
  disabled?: boolean;
  className?: string;
  onValueChange?: (value: number[]) => void;
}

export function Slider({ value, min, max, step, disabled, className, onValueChange }: SliderProps) {
  const val = Array.isArray(value) ? value[0] : value ?? 0;
  return (
    <input
      type="range"
      min={min}
      max={max}
      step={step}
      disabled={disabled}
      className={className}
      value={val}
      onChange={(e) => {
        onValueChange?.([Number(e.target.value)]);
      }}
    />
  );
}
